
define('router',[
    // Application.
    "app",

    // Modules
    "modules/application",
    "modules/application/wizard",
    "modules/application/subheader",
    "modules/application/widgets/consumptionIndicator",
  ],

  function(app, Application, Wizard, Subheader, ConsumptionIndicator) {

    // Defining the application router, you can attach sub routers here.
    var Router = Backbone.Router.extend({
      routes: {
        "": "quoteTypesMenu",
        "system-selection-multi": "systemSelectionMulti",
        "system-selection-single": "systemSelectionSingle",
        "antintrusione/kit/:kitCode": "antintrusioneWithKit",
        "termoregolazione": "termoregolazione",
        "antintrusione": "antintrusione",
        "audiovideo": "audiovideo",
        "automazione": "automazione",
        "automazioneSemplice": "automazioneSemplice",
        "gestioneEnergia": "gestioneEnergia",
        "system-selection-single/antintrusione": "antintrusioneWebapp",
        "system-selection-single/audiovideo": "audiovideoWebapp",
        "system-selection-single/automazione": "automazioneWebapp",
        "system-selection-single/automazioneSemplice": "automazioneSempliceWebapp",
        "system-selection-single/gestioneEnergia": "gestioneEnergiaWebapp",
        "system-selection-single/termoregolazione": "termoregolazioneWebapp",
        "forward": "forwardProject",
        "*path": "quoteTypesMenu"
      },

      base: function() {
        if (!window.BticinoS4B.Instances.Views.ApplicationView) {
          window.BticinoS4B.Instances.Views.ApplicationView = new Application.View();
          window.BticinoS4B.Instances.Views.Layout.setView(window.BticinoS4B.Instances.Views.ApplicationView);
        }
      },
      checkParameter: function() {
        var accessoryLineId = this.urlParam('accessoryLineId');
        var kitCode = this.urlParam('kit');
        if (accessoryLineId) {
          var accessoryLines = window.BticinoS4B.Instances.Models.ApplicationModel.get('accessoryLines'),
            line = {},
            color = {};
          for (var i = 0; i < accessoryLines.length; i++) {
            for (var j = 0; j < accessoryLines[i].colors.length; j++) {
              if (accessoryLines[i].colors[j].accessoryLineId === accessoryLineId) {
                color = accessoryLines[i].colors[j];
                line = accessoryLines[i];
              }
            }
          }
          if (color.id) {
            window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenColor", color);
            window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenLine", line);
            window.BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLineId", color.accessoryLineId);
          } else {
            window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenColor", null);
            window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenLine", line);
            window.BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLineId", line.id);
          }
          BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new ConsumptionIndicator.Model());
        }
        if (kitCode)
          BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", kitCode);
      },
      urlParam: function(name) {
        var results = new RegExp('[\\?&amp;]' + name + '=([^&amp;#]*)').exec(window.location.href);
        if (results)
          return results[1];
        else return false;
      },

      quoteTypesMenu: function() {
        this.base();
        // Create a layout and associate it with the #main div.
        window.BticinoS4B.eventAggregator.trigger("system:changed", {
          id: undefined,
          appName: undefined,
          quoteType: undefined
        });

        // Render the layout into the DOM.
        //window.BticinoS4B.Instances.Views.Layout.render();
      },

      forwardProject: function() {
        this.base();
        var projectIDParam = this.urlParam('projectID');
        if (projectIDParam) {
          var projectID = BticinoS4B.ConversionManager.h2d(projectIDParam);
          window.BticinoS4B.Instances.Models.ApplicationModel.set("forwardProject", projectID);
          if (window.BticinoS4B.Instances.Models.loginModel.isAuthenticated()) {
            BticinoS4B.Instances.Services.wizardServices.duplicateProject(BticinoS4B.Instances.Models.ApplicationModel.get("forwardProject"), BticinoS4B.Instances.Views.ApplicationView.__proto__.successProjectForwardCallback);

            if (BticinoS4B.Instances.Models.QuoteTypesMenuModel.get('quoteType') == 'webapp') {
              if (BticinoS4B.modelToLoad && BticinoS4B.modelToLoad.audioVideo) {
                window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.audioVideo);
              } 
              else if (BticinoS4B.modelToLoad && BticinoS4B.modelToLoad.thermoregulation) {
                window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.thermoregulation);
              } 
              else if (BticinoS4B.modelToLoad && BticinoS4B.modelToLoad.intrusionDetection) {
                window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.intrusionDetection);
              } 
              else if (BticinoS4B.modelToLoad && BticinoS4B.solution.modelToLoad) {
                window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.automation);
              } 
              else if (BticinoS4B.modelToLoad && BticinoS4B.solution.modelToLoad) {
                window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.automationSimple);
              } 
              else if (BticinoS4B.modelToLoad && BticinoS4B.solution.modelToLoad) {
                window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.energyManagement);
              }
            }
          } else {
            window.BticinoS4B.eventAggregator.trigger("system:changed", {
              id: undefined,
              appName: undefined,
              quoteType: undefined
            });
          }
        }
      },

      systemSelectionMulti: function() {
        this.base();
        // Create a layout and associate it with the #main div.
        window.BticinoS4B.eventAggregator.trigger("system:changed", {
          id: undefined,
          appName: undefined,
          quoteType: 's4b'
        });

        // Render the layout into the DOM.
        //window.BticinoS4B.Instances.Views.Layout.render();
      },

      systemSelectionSingle: function() {
        this.base();
        // Create a layout and associate it with the #main div.
        window.BticinoS4B.eventAggregator.trigger("system:changed", {
          id: undefined,
          appName: undefined,
          quoteType: 'webapp'
        });

        // Render the layout into the DOM.
        //window.BticinoS4B.Instances.Views.Layout.render();
      },

      termoregolazione: function() {
        this.base();
        // Create a layout and associate it with the #main div.
        // Insert the tutorial into the window.BticinoS4B.Instances.Views.Layout.

        window.BticinoS4B.eventAggregator.trigger("system:changed", {
          id: "#2",
          appName: 'termoregolazione',
          quoteType: window.BticinoS4B.Instances.Models.QuoteTypesMenuModel.get('quoteType')
        });

        if (BticinoS4B.solution.thermoregulation.inserted && BticinoS4B.modelToLoad.thermoregulation) {
          window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.thermoregulation);
        }

        // Render the layout into the DOM.
        // window.BticinoS4B.Instances.Views.Layout.render();

      },
      termoregolazioneWebapp: function() {
        this.base();
        // Create a layout and associate it with the #main div.
        // Insert the tutorial into the window.BticinoS4B.Instances.Views.Layout.
        BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteTypeDefined', true);
        BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteType', 'webapp');

        window.BticinoS4B.eventAggregator.trigger("system:changed", {
          id: "#2",
          appName: 'termoregolazione'
        });
        if (BticinoS4B.solution.thermoregulation.inserted && BticinoS4B.modelToLoad.thermoregulation) {
          window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.thermoregulation);
        }

        // Render the layout into the DOM.
        // window.BticinoS4B.Instances.Views.Layout.render();
      },

      antintrusioneWithKit: function(kitCode) {
        this.base();
        // Create a layout and associate it with the #main div.
        // Insert the tutorial into the window.BticinoS4B.Instances.Views.Layout.
        window.BticinoS4B.eventAggregator.trigger("system:changed", {
          id: "#4",
          appName: 'antintrusione',
          kitCode: kitCode
        });

        if (BticinoS4B.solution.intrusionDetection.inserted && BticinoS4B.modelToLoad.intrusionDetection) {
          window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.intrusionDetection);
        }

        // Render the layout into the DOM.
        //window.BticinoS4B.Instances.Views.Layout.render();
      },
      antintrusioneWebapp: function() {
        this.base();
        // Create a layout and associate it with the #main div.
        // Insert the tutorial into the window.BticinoS4B.Instances.Views.Layout.

        BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteTypeDefined', true);
        BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteType', 'webapp');
        this.checkParameter();

        window.BticinoS4B.eventAggregator.trigger("system:changed", {
          id: "#4",
          appName: 'antintrusione'
        });

        if (BticinoS4B.solution.intrusionDetection.inserted && BticinoS4B.modelToLoad.intrusionDetection) {
          window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.intrusionDetection);
        }

        // Render the layout into the DOM.
        //window.BticinoS4B.Instances.Views.Layout.render();
      },

      antintrusione: function() {
        this.base();
        // Create a layout and associate it with the #main div.
        // Insert the tutorial into the window.BticinoS4B.Instances.Views.Layout.


        window.BticinoS4B.eventAggregator.trigger("system:changed", {
          id: "#4",
          appName: 'antintrusione',
          quoteType: window.BticinoS4B.Instances.Models.QuoteTypesMenuModel.get('quoteType')
        });

        if (BticinoS4B.solution.intrusionDetection.inserted && BticinoS4B.modelToLoad.intrusionDetection) {
          window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.intrusionDetection);
        }

        // Render the layout into the DOM.
        //window.BticinoS4B.Instances.Views.Layout.render();
      },
      audiovideoWebapp: function() {
        this.base();
        // Create a layout and associate it with the #main div.
        // Insert the tutorial into the window.BticinoS4B.Instances.Views.Layout.
        BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteTypeDefined', true);
        BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteType', 'webapp');
        window.BticinoS4B.eventAggregator.trigger("system:changed", {
          id: "#5+6",
          appName: 'audiovideo'
        });

        if (BticinoS4B.solution.audioVideo.inserted && BticinoS4B.modelToLoad.audioVideo) {
          window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.audioVideo);
        }

        // Render the layout into the DOM.
        //window.BticinoS4B.Instances.Views.Layout.render();
      },

      audiovideo: function() {
        this.base();
        // Create a layout and associate it with the #main div.
        // Insert the tutorial into the window.BticinoS4B.Instances.Views.Layout.

        window.BticinoS4B.eventAggregator.trigger("system:changed", {
          id: "#5+6",
          appName: 'audiovideo',
          quoteType: window.BticinoS4B.Instances.Models.QuoteTypesMenuModel.get('quoteType')
        });

        if (BticinoS4B.solution.audioVideo.inserted && BticinoS4B.modelToLoad.audioVideo) {
          window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.audioVideo);
        }

        // Render the layout into the DOM.
        //window.BticinoS4B.Instances.Views.Layout.render();
      },
      automazioneWebapp: function() {
        this.base();
        BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteTypeDefined', true);
        BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteType', 'webapp');
        this.checkParameter();
        // Create a layout and associate it with the #main div.
        window.BticinoS4B.eventAggregator.trigger("system:changed", {
          id: "#13+20",
          appName: 'automazione'
        });

        if (BticinoS4B.solution.automation.inserted && BticinoS4B.solution.modelToLoad) {
          window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.automation);
        }

        // Render the layout into the DOM.
        //window.BticinoS4B.Instances.Views.Layout.render();
      },

      automazioneSempliceWebapp: function() {
        this.base();
        BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteTypeDefined', true);
        BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteType', 'webapp');
        this.checkParameter();
        // Create a layout and associate it with the #main div.
        window.BticinoS4B.eventAggregator.trigger("system:changed", {
          id: "#13",
          appName: 'automazioneSemplice'
        });

        if (BticinoS4B.solution.automationSimple.inserted && BticinoS4B.solution.modelToLoad) {
          window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.automationSimple);
        }

        // Render the layout into the DOM.
        //window.BticinoS4B.Instances.Views.Layout.render();
      },

      gestioneEnergiaWebapp: function() {
        this.base();
        BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteTypeDefined', true);
        BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteType', 'webapp');
        this.checkParameter();
        // Create a layout and associate it with the #main div.
        window.BticinoS4B.eventAggregator.trigger("system:changed", {
          id: "#21",
          appName: 'gestioneEnergia'
        });

        if (BticinoS4B.solution.energyManagement.inserted && BticinoS4B.solution.modelToLoad) {
          window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.energyManagement);
        }

        // Render the layout into the DOM.
        //window.BticinoS4B.Instances.Views.Layout.render();
      },

      automazione: function() {
        this.base();
        var kitCode = BticinoS4B.Instances.Models.ApplicationModel.get("kitCode");
        if (kitCode) {
          window.BticinoS4B.eventAggregator.trigger("system:changed", {
            id: "#13+20",
            appName: 'automazione',
            kitCode: kitCode
          });
        } else {
          // Create a layout and associate it with the #main div.
          window.BticinoS4B.eventAggregator.trigger("system:changed", {
            id: "#13+20",
            appName: 'automazione',
            quoteType: window.BticinoS4B.Instances.Models.QuoteTypesMenuModel.get('quoteType')
          });
        }

        if (BticinoS4B.solution.automation.inserted && BticinoS4B.modelToLoad.automation) {
          window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.automation);
        }

        // Render the layout into the DOM.
        //window.BticinoS4B.Instances.Views.Layout.render();
      },

      automazioneSemplice: function() {
        this.base();
        var kitCode = BticinoS4B.Instances.Models.ApplicationModel.get("kitCode");
        if (kitCode) {
          window.BticinoS4B.eventAggregator.trigger("system:changed", {
            id: "#13",
            appName: 'automazioneSemplice',
            kitCode: kitCode
          });
        } else {
          // Create a layout and associate it with the #main div.
          window.BticinoS4B.eventAggregator.trigger("system:changed", {
            id: "#13",
            appName: 'automazioneSemplice',
            quoteType: window.BticinoS4B.Instances.Models.QuoteTypesMenuModel.get('quoteType')
          });
        }

        if (BticinoS4B.solution.automationSimple.inserted && BticinoS4B.modelToLoad.automationSimple) {
          window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.automationSimple);
        }

        // Render the layout into the DOM.
        //window.BticinoS4B.Instances.Views.Layout.render();
      },

      gestioneEnergia: function() {
        this.base();
        var kitCode = BticinoS4B.Instances.Models.ApplicationModel.get("kitCode");
        if (kitCode) {
          window.BticinoS4B.eventAggregator.trigger("system:changed", {
            id: "#21",
            appName: 'gestioneEnergia',
            kitCode: kitCode
          });
        } else {
          // Create a layout and associate it with the #main div.
          window.BticinoS4B.eventAggregator.trigger("system:changed", {
            id: "#21",
            appName: 'gestioneEnergia',
            quoteType: window.BticinoS4B.Instances.Models.QuoteTypesMenuModel.get('quoteType')
          });
        }

        if (BticinoS4B.solution.energyManagement.inserted && BticinoS4B.modelToLoad.energyManagement) {
          window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.energyManagement);
        }

        // Render the layout into the DOM.
        //window.BticinoS4B.Instances.Views.Layout.render();
      }

    });

    return Router;

  });